import { Fish } from "lucide-react";

export default function ProductImage({ product, className = "", eager = false, compact = false }) {
  if (product.image) {
    return (
      <div className={`flex items-center justify-center bg-white ${className}`}>
        <img
          src={product.image}
          alt={product.name}
          loading={eager ? "eager" : "lazy"}
          className="h-full w-full object-contain p-4"
        />
      </div>
    );
  }
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 bg-cream px-6 text-center ${className}`}
      data-testid={`product-image-fallback-${product.id}`}
    >
      <Fish className="h-8 w-8 text-bronze" aria-hidden="true" />
      {!compact && (
        <p className="font-display text-sm leading-snug text-charcoal/75">
          {product.name}
        </p>
      )}
    </div>
  );
}
